import { useEffect } from 'react';
import { If } from '../../Atoms/Conditionals';
import { usePartnerPageContext } from '../context';
import useCopy from './hooks/use-copy';
import { extractCoupon } from './utils';

export const CouponAvail = ({
  setCouponCode,
  couponCode,
  hideFirstFold,
}: {
  setCouponCode: (value: { discount: number; coupon: string | null }) => void;
  couponCode: {
    discount: number;
    coupon: string | null;
  };
  hideFirstFold: boolean;
}) => {
  const { selfITRPlansData } = usePartnerPageContext();
  const delay = 1000;
  const { copied, handleCopyCoupon } = useCopy(couponCode?.coupon || '', delay);

  useEffect(() => {
    setCouponCode(extractCoupon(selfITRPlansData));
  }, []);

  const partnerSlug = selfITRPlansData?.[0]?.partnerSlug;
  if (partnerSlug === 'partner-abcdl') {
    return <></>;
  }

  return (
    <If condition={!!couponCode.coupon}>
      <div
        className={`flex px-2.5 bg-black items-center justify-center w-full leading-7 sticky top-0 z-100 pointer-events-none ${
          !hideFirstFold ? 'mt-2 sm:mt-16' : ''
        }`}
      >
        <div
          className="w-full flex items-center justify-center gap-6 cursor-pointer sm:flex"
          onClick={handleCopyCoupon}
          data-testid="copyCoupon"
        >
          <p className="text-base text-amber-100 text-center sm:text-left sm:w-[210px] font-medium">
            Avail exclusive discount on{' '}
            <span className="font-semibold text-base">Tax Filing</span> using
            this coupon!
          </p>
          <div className="flex gap-2.5 pointer-events-auto items-center">
            <p className="text-base text-amber-400 font-semibold">
              {couponCode.coupon}
            </p>

            <img
              className="w-6 h-6"
              src={
                copied
                  ? 'https://assets.clear.in/cleartax/images/1712001391_checkcircle1.svg'
                  : 'https://assets.clear.in/cleartax/images/1714203952_copy.svg'
              }
              alt="copy coupon"
            />
          </div>
        </div>
      </div>
    </If>
  );
};
